module.exports = __webpack_public_path__ + "static/trash.b0429ec5441f84f59752220179d9ab1c.svg";